// Hooks
import useTranslate from "hooks/useTranslate";

// Type
import { FooterNavigationType } from "../../../constants/navigation";

import "./styles.sass";

type FooterNavigationItemProps = {
  item: FooterNavigationType;
  onClick: () => void;
};

const FooterNavigationItem = (props: FooterNavigationItemProps) => {
  const { item, onClick } = props;

  const t = useTranslate();

  return (
    // eslint-disable-next-line react/jsx-handler-names
    <div className="FooterNavigationItem" onClick={onClick}>
      {t(item.name)}
    </div>
  );
};

export default FooterNavigationItem;
